export function updateUserRole(value: string) {
  return {
    type: "@@APP_COMMON/UPDATE_USER_ROLE",
    payload: value,
  };
}
